/** URL slug for each message tab (used in ?tab=) */
export const MESSAGE_TAB_SLUGS = {
  'All': 'all',
  'Unread Priority': 'unread-priority',
  'Priority': 'priority',
  'Messages': 'messages',
  'Archived': 'archived',
};

export const MEDIA_ICON_MAP = {
  image: 'fa-image',
  video: 'fa-video',
  bundle: 'fa-images',
  file: 'fa-file',
};

export const MESSAGE_TIP_STATUS = {
  PAID: 1,
  UNPAID: 2,
  PENDING_CREATOR_REPLY: 5,
  REFUNDED: 6,
};

const CHAT_THREAD_PAGE_SIZE = 30;

export const MESSAGE_CONSTANTS = {
  SCROLL_NEAR_BOTTOM_THRESHOLD_PX: 140,
  /** Distance from top (px) to trigger loading older messages; larger = less sensitive, smoother scroll */
  SCROLL_TOP_THRESHOLD_PX: 120,
  /** Displayable messages shown when a 1:1 thread first opens. */
  INITIAL_VISIBLE_MESSAGES: CHAT_THREAD_PAGE_SIZE,
  /** Displayable messages to append each time the user scrolls to the top. */
  LOAD_OLDER_PAGE_SIZE: CHAT_THREAD_PAGE_SIZE,
};

export const PREVIEW_CHAR_LIMIT = 39;
// export const MESSAGE_REPLY_DEADLINE_DAYS_NOTIFY = 5;
export const MESSAGE_REPLY_DEADLINE_DAYS_NOTIFY = 10;
export const MESSAGE_REPLY_DEADLINE_DAYS = 10;
export const MESSAGE_REPLY_DEADLINE_DAYS_EXTENDED = 5;
export const MESSAGE_DEADLINE_DAYS_EXTENDED_NOTIFY = 3;
export const CREDITS_DISPLAY_TEXT = 'Credits: 0';
export const WHALE_THRESHOLD = 500; // $500
/** Page size for `/matrix/rooms` and `/matrix/all-rooms` backend metadata. */
export const MATRIX_ROOMS_PAGE_LIMIT = 100;
/** Max pages to auto-fetch in one until-complete run (PAGE_LIMIT × this ≈ max rooms). */
export const MATRIX_ROOMS_MAX_AUTO_PAGES = 100;

/** Map slug back to filter title */
export const MESSAGE_TAB_FROM_SLUG = Object.fromEntries(
  Object.entries(MESSAGE_TAB_SLUGS).map(([title, slug]) => [slug, title])
);

export const CREATOR_SECTIONS = [
  {
    icon: "💰",
    title: "Unread Priority Messages",
    description: "A subscriber tipped with their first message.",
    items: [
      "You have 10 days to reply or the subscribers tip is automatically refunded. When there's 5 days remaining to respond the subscriber has the option to extend the deadline by an additional 5 days.",
      "Once you reply you will collect the tip amount and all future tips and purchases will automatically go straight to your wallet (no reply needed). The chat will then move from your Unread Priority inbox to your Priority inbox.",
    ],
  },
  {
    icon: "✨",
    title: "Priority Messages",
    description: "A subscriber tipped on their first messages, you replied and they are now a priority user.",
    items: [
      "You do not need to reply to collect tips in the Priority inbox.",
      "If the subscriber stops spending money for a full 60 days they will move to your Messages inbox and lose priority status.",
      "A whale emoji beside a username means the user spent $500 or more within 60 days.",
    ],
  },
  {
    icon: "💬",
    title: "Messages",
    description: "A subscriber that has not tipped with their message.",
    items: [
      "A subscriber needs to spend $100 within 60 days to gain priority status.",
      "If a subscriber moves to your Priority inbox but stops spending money for a full 60 days they will move back to your Messages inbox.",
    ],
  },
  {
    icon: "📞",
    title: "Voice & Video Call",
    description: "Start a private 1-on-1 voice or video call with a subscriber by tapping the phone or video icon in chat.",
    items: [
      "Tap the voice or video call icons in a chat to view or set your rate and send call requests.",
      "Requests are sent instantly.",
      "Once a call request is sent or received, you have 3 minutes to join before the call is automatically canceled.",
      "Subscribers won't be charged until both of you have joined the call.",
      "Once a call begins subscribers are billed per minute. This applies whether you set a per minute rate or a flat session fee. For example, charging $125 for 30 minutes is $4.17 per minute.",
      "If a minimum time is set and the subscriber ends the call early you will still receive the full minimum rate. However, if you end the call early the subscriber will only be charged per minute for the actual time spent on the call.",
      "By setting a minimum call time subscribers can only connect if they have the funds to cover it so you are always set to collect your minimum fee.",
    ],
  },
  {
    icon: "📦",
    title: "Archived",
    description: "Users can only message you if they follow or are subscribed to you.",
    items: [
      "Once a subscriber unfollows or unsubscribes to you chats are archived and locked.",
      "To unlock a chat the subscriber will need to follow or subscribe to you again.",
      "You can still send a message to a subscriber even if the chat is locked but they won't be able to reply until they follow or subscribe again.",
    ],
  },
];

export const USER_SECTIONS = [
  {
    icon: "💰",
    title: "Unread Priority Messages",
    description: "You tipped with your first message.",
    items: [
      "The creator has 10 days to reply or your tip is automatically refunded.",
      "When there's 5 days remaining you can extend the deadline by an additional 5 days.",
    ],
  },
  {
    icon: "✨",
    title: "Priority Messages",
    description: "You tipped, received a reply and you're now a priority user for this creator.",
    items: [
      "If you go 60 days without spending you will lose priority status and be moved out of the creators Priority inbox.",
      "To regain priority status spend $120 within 60 days and you will be moved back into the creator's Priority inbox.",
    ],
  },
  {
    icon: "💬",
    title: "Messages",
    description: "You sent a first message without tipping so you are not a priority user.",
    items: [
      "Spend $120 within 60 days to gain priority status.",
      "If you go 60 days without spending you will move back to the regular inbox.",
    ],
  },
  {
    icon: "📞",
    title: "Voice & Video Call",
    description: "Start a private 1-on-1 voice or video call by tapping the phone or video icon in the chat.",
    items: [
      "Credits are required for calls. You can purchase them from the Credits button in your inbox.",
      "Requests are sent instantly. Once a call request is sent or received, you have 3 minutes to join before the call is automatically canceled.",
      "Once a call begins billing runs per minute.",
      "If you end early but the creator has a minimum time, you are charged the minimum.",
      "You must have enough credits to cover the minimum before starting the call.",
    ],
  },
  {
    icon: "📦",
    title: "Archived",
    description: "You can only message a creator if you subscribe or follow them.",
    items: [
      "If you unsubscribe or unfollow a creator chats are archived and locked.",
      "To unlock the chat simply subscribe or follow again.",
    ],
  },
];